import fileDefault from './file-blank-solid-240.png';
import fileCSS from './file-css-solid-240.png';
import filePdf from './file-pdf-solid-240.png';
import filePng from './file-png-solid-240.png';

export const ImageConfig = {
    default: fileDefault,
    pdf: filePdf,
    png: filePng,
    css: fileCSS
}